/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  FontWeight,
  Popover, Spacing, Stack, Text,
  UserPreview,
} from '@doveit/bricks';
import { HRInterview, JobApplication } from '../../../providers/api/dtos';
import { removeNullAndUndefinedValues } from '../../../utils/array';
import { JobApplicationType } from '../../../domain/types';
import { ViewAgentSmallPreview } from '../../../agent/components';
import { jobTitleLabels } from '../../../labels';
import { jobApplicationAssigneeUsers, jobApplicationHrUsers } from '../../../job-application/constants';
import * as styles from './ViewHRInterviewParticipantsPreview.style';

export interface ViewHRInterviewParticipantsPreviewProps extends React.AriaAttributes {
  hrInterview: HRInterview,
  jobApplication: JobApplication,
}

const ViewHRInterviewParticipantsPreview: React.FC<ViewHRInterviewParticipantsPreviewProps> = ({
  hrInterview,
  jobApplication,
  ...rest
}) => {
  const [interviewer, extraParticipant] = React.useMemo(() => {
    const emails = removeNullAndUndefinedValues([hrInterview.interviewerEmail, hrInterview.extraParticipantEmail]);

    return [...new Set(emails)];
  }, [hrInterview.extraParticipantEmail, hrInterview.interviewerEmail]);

  return (
    <Popover
      trigger={(
        <div css={styles.hrInterviewParticipantsPreviewWrapper}>
          {interviewer && jobApplication.applicationType === JobApplicationType.SALES && (
            <ViewAgentSmallPreview
              agentIdOrEmail={interviewer}
              aria-label="Anteprima esaminatore"
              size="S"
              omit={{ name: true }}
            />
          )}
          {interviewer && jobApplication.applicationType !== JobApplicationType.SALES && (
            <UserPreview
              size="S"
              aria-label="Anteprima esaminatore"
            />
          )}

          {extraParticipant && (
            <UserPreview
              size="S"
              aria-label="Anteprima partecipante extra"
            />
          )}
        </div>
      )}
      hasArrow
      {...rest}
    >
      <Spacing padding={150}>
        <Stack gap={100}>
          <Text.BodySmall
            as="strong"
            fontWeight={FontWeight.MEDIUM}
          >
            Partecipanti Dove.it
          </Text.BodySmall>

          {interviewer && jobApplication.applicationType === JobApplicationType.SALES && (
            <ViewAgentSmallPreview
              size="S"
              agentIdOrEmail={interviewer}
              aria-label="Anteprima esaminatore"
              details={({ jobTitle }) => `Esaminatore - ${jobTitleLabels[jobTitle]}`}
            />
          )}
          {interviewer && jobApplication.applicationType !== JobApplicationType.SALES && (
            <UserPreview
              name={[...jobApplicationAssigneeUsers, ...jobApplicationHrUsers].find(({ email }) => email === interviewer)?.name}
              size="S"
              aria-label="Anteprima esaminatore"
            >
              Esaminatore - HR
            </UserPreview>
          )}

          {extraParticipant && (
            <UserPreview
              name={jobApplicationHrUsers.find(({ email }) => email === extraParticipant)?.name}
              aria-label="Anteprima partecipante extra"
              size="S"
            >
              Partecipante extra - HR
            </UserPreview>
          )}
        </Stack>
      </Spacing>
    </Popover>
  );
};

export default ViewHRInterviewParticipantsPreview;
